import FormValidator from '../form/form-validator.js'
import url from '../../utils/url.js'
import saveFile from "../../utils/saveFile"
import FileSaver from 'file-saver'
import {ExportItems} from "../../utils/export/ExportItems"

export default {
  data () {
    this.stopAsync = false
    return {
      /* required for table */
      checkedItems: [],
      filterModel: {},
      searchInProgress: false,
      showFilter: false
    }
  },
  watch: {
    '$route': 'onRouteHandler',
    'items': 'onItems'
  },
  computed: {
    filterFormName () {
      return ''
    },
    items () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.getEndpoint(this.$route)) ??
        { data: [], _meta: { fields: {} } }
    },
    prevRoute () {
      return url.getRoute(this.$route, true)
    },
    exportItemsToFormat () {
      return null
    },
    exportItemsChunkSize () {
      return 500
    }
  },
  created () {
    this.formValidator = new FormValidator(this)
    this.setFiltersFromUrlTo()
    this.setShowFilterStateFromUrl()
  },
  mounted () {
    this.onItems()
  },
  destroyed () {
    this.stopAsync = true
  },
  methods: {
    /**
     * @returns {{route: *, json: *}}
     */
    getRoute () {
      let route = url.getRoute(this.$route)
      let json = url.getRoute(this.$route, true)
      return {route, json}
    },
    onOpenFilterPanel () {
      let route = url.getRoute(this.$route)
      route.query.showFilter = true
      this.$router.replace(route)
    },
    onCloseFilterPanel () {
      let route = url.getRoute(this.$route)
      route.query.showFilter = false
      this.$router.replace(route, () => {
        setTimeout(() => this.resetFilter(), 0)
      })
    },
    getDownloadEndpoint (row) {
      return null
    },
    startDownloadFile (row) {
      this.$bar.start()
      this.$sharedServices.store.dispatch('downloadFile', {
        endpoint: this.getDownloadEndpoint(row)
      }).then(r => {
        this.$bar.finish()
        saveFile({
          blob: r.request.response,
          headers: r.headers
        })
      }).catch(e => {
        this.$bar.finish()
        this.$e.errorBox(e)
      })
    },
    onDownload () {
      if (this.exportItemsToFormat === null) {
        this.startDownloadFile(null)
      } else {
        this.exportItemsToFile()
      }
    },
    /**
     * @param chunkSize
     * @param streams
     * @returns {IterableIterator<Promise<any[] | never>>}
     */
    *getAllItems (chunkSize, streams = 3) {
      let pages = 1
      let page = 1
      chunkSize = chunkSize || this.exportItemsChunkSize
      while (page <= pages) {
        // create ajax streams for promise all
        const promises = []
        for (let streamNum = 0; streamNum < streams; streamNum++) {
          const endpoint = this.getEndpoint({
            query: {
              isExportItems: true,
              'per-page': chunkSize,
              page: page + streamNum,
              sort: 'id'
            }
          })

          promises.push(this.$sharedServices.store.dispatch('updateUrlEndpoint', {
            endpoint,
            notReactive: false,
            fromCache: false,
            params: {
              disableGlobalError: true
            }
          }).then(({data}) => {
            pages = data._meta.pageCount
            console.log(page, 'of', pages, endpoint)
            page++
            return data
          }))

          // if streams count > pages count = end
          if (promises.length + page > pages) {
            break
          }
        }

        yield Promise.all(promises).then(dataItems => {
          const out = dataItems[0]
          for (let iI = 1; iI < dataItems.length; iI++) {
            out.data = [...out.data, ...dataItems[iI].data]
          }
          console.log(out)
          return out
        })
      }
    },
    async exportItemsToFile() {
      try {
        this.$bar.start()

        const fileName = `${this.$route.meta ? this.$route.meta.title : 'data'}_${new Date().toUTCString()}`
        const eI = new ExportItems()
          .setFormat(this.exportItemsToFormat)
          .setFields(this.items._meta.fields)

        for await (let {data} of this.getAllItems()) {
          eI.appendData(data)

          if (this.stopAsync === true) {
            console.log('iterator stopped')
            return
          }
        }

        const file = await eI.toFile(fileName)
        FileSaver.saveAs(file)
      } catch (e) {
        this.$e.errorBox(e)
      } finally {
        this.$bar.finish()
      }
    },
    getPrevOrCurrentRouteQuery (route) {
      return url.getPrevOrCurrentRoute(route)
    },
    onRouteHandler () {
      this.setFiltersFromUrlTo()
      this.setShowFilterStateFromUrl()
    },
    buildQueryFromSearchModel (inputQuery, model) {
      let query = Object.assign({}, inputQuery)
      for (let fieldName in model) {
        let name = this.filterFormName
          ? `${this.filterFormName}[${fieldName}]`
          : `${fieldName}`
        if (Array.isArray(model[fieldName])) {
          query[name] = model[fieldName]
        } else {
          query[name] = model[fieldName]
        }
        if (query[name] === null || query[name].length === 0) {
          delete query[name]
        }
      }
      return query
    },
    setShowFilterStateFromUrl () {
      if (this.$route.query.hasOwnProperty('showFilter')) {
        this.showFilter = this.$route.query.showFilter === true || this.$route.query.showFilter === 'true'
        console.log('showFilter', this.showFilter)
      }
    },
    setFiltersFromUrlTo (model = 'filterModel') {
      if (!this[model]) {
        console.error('Please define the object with name = ', model)
      }
      for (let fieldName in this[model]) {
        let name = this.filterFormName
          ? `${this.filterFormName}[${fieldName}]`
          : `${fieldName}`
        if (this.$route.query && this.$route.query.hasOwnProperty(name)) {
          if (Array.isArray(this[model][name])) {
            if (Array.isArray(this.$route.query[name])) {
              this[model][fieldName] = this.$route.query[name]
            } else {
              this[model][fieldName] = [this.$route.query[name]]
            }
          } else {
            this[model][fieldName] = this.$route.query[name]
          }
        } else {
          if (Array.isArray(this[model][fieldName])) {
            this[model][fieldName] = []
          } else {
            this[model][fieldName] = ''
          }
        }
      }
    },
    getNewFilterInstance () {
      const copiedModel = {}
      for (let fName in this.filterModel) {
        if (Array.isArray(this.filterModel[fName])) {
          copiedModel[fName] = []
        } else if (typeof this.filterModel[fName] === 'object') {
          copiedModel[fName] = {}
        } else {
          copiedModel[fName] = ''
        }
      }
      return copiedModel
    },
    applyFilter () {
      if (this.searchInProgress) {
        return
      }

      const {hasError} = this.formValidator.validate()
      if (hasError === false) {
        this.setFilterModelToQuery()
      }
    },
    resetFilter () {
      if (this.searchInProgress) {
        return
      }

      this.filterModel = this.getNewFilterInstance()
      this.formValidator.resetAllErrors()
      this.setFilterModelToQuery()
    },
    setFilterModelToQuery () {
      if (this.searchInProgress) {
        return
      }

      let route = url.getRoute(this.$route)
      let model = JSON.parse(JSON.stringify(this.filterModel))
      route.query = this.transformFilterModelToQuery(
        this.buildQueryFromSearchModel(route.query, model)
      )
      this.searchInProgress = true
      this.$router.push(route, () => {
        this.searchInProgress = false
        this.checkIfItemsHasValidationErrors()
      }, () => {
        // user may think all data reloaded
        this.$bar.start()
        this.$bar.finish()
        this.searchInProgress = false
        this.checkIfItemsHasValidationErrors()
      })
    },
    transformFilterModelToQuery (modelDeepCopy) {
      return modelDeepCopy
    },
    deleteItems () {
      console.log(this.checkedItems)
      if (this.checkedItems && this.checkedItems.length > 0) {
        this.confirmBox('Удаленные записи нельзя будет восстановить', 'Удалить записи?').then(() => {
          let promises = []
          this.checkedItems.forEach((id) => {
            promises.push(this.$sharedServices.store.dispatch('deleteModel', {
              url: this.getDeleteUrl(id),
              endpoint: this.getEndpoint(this.$route)
            }))
          })
          Promise.all(promises).then(r => {
            this.showOnSuccessDeleteAll('Записи удалены')
            this.reFetchData()
          }).catch(er => {
            console.error(er)
            this.showOnError(er)
          })
        }).catch(e => e)
      }
    },
    confirmBox (
      msg = 'Удаленную запись нельзя будет восстановить',
      title = 'Удалить запись?',
      confirmBtnText = 'Удалить'
    ) {
      return this.$e.confirmBox(msg, title, confirmBtnText)
    },
    showOnError (er) {
      this.$e.errorBox(er)
    },
    showOnSuccess (title = 'Действие успешно завершено') {
      this.$e.successBox(title)
    },
    showOnSuccessDeleteAll (title) {
      this.$e.successBox(title)
    },
    deleteItem (item) {
      this.confirmBox().then(() => {
        this.$sharedServices.store.dispatch('deleteModel', {
          url: this.getDeleteUrl(item.id),
          data: {id: item.id},
          endpoint: this.getEndpoint(this.$route)
        }).then(r => {
          this.showOnSuccess('Запись удалена')
        }).catch(erResponse => {
          this.showOnError(erResponse)
        })
      })
    },
    editItem (item) {
      let prevRoute = url.getRoute(this.$route, true)
      this.$router.push({
        name: this.$route.name + '.update',
        params: {id: item.id},
        query: {
          prevRoute: prevRoute
        }
      })
    },
    reFetchData () {
      this.$bar.startOrContinue()
      let {asyncData} = this.$options
      asyncData({
        store: this.$sharedServices.store,
        route: this.$sharedServices.route,
        fromRoute: null,
        methods: this
      }).then(r => {
        this.$bar.finish()
      }).catch(e => {
        this.showOnError(e)
        this.$bar.finish()
      })
    },
    /**
     * Proceed 422 validation errors
     * @param options
     */
    onMutateError (options) {
      const {response, commitError, config, store} = options
      if (response && +response.status === 422) {
        store.commit('mutateEndpoint', {endpoint: config.url, response})
      } else {
        commitError(options)
      }
    },
    onItems () {
      this.checkIfItemsHasValidationErrors()
    },
    /**
     * On validation errors, copy errors to error validator
     */
    checkIfItemsHasValidationErrors () {
      const response = {
        data: this.items
      }
      if (response.data && response.data.errors) {
        let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(response, this)
        if (notFoundedErrorFieldsText) {
          this.$e.errorBox(
            'Некорректно заполнены поля',
            {text: notFoundedErrorFieldsText}
          )
        }
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    const endpoint = methods.getEndpoint(route, fromRoute)
    // if open modal
    if (fromRoute) {
      let jsonRoute = url.getRoute(fromRoute, true)

      if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
        // fix: https://redmine.etton.ru/issues/13458
        if (store.getters.readUrlEndpoint(endpoint)) {
          return Promise.resolve(1)
        }
      }
    }

    return store.dispatch('updateUrlEndpoint', {
      endpoint,
      params: {
        onMutateError: methods.onMutateError
      }
    })
  }
}
